import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3619d7f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-stt-dot",
  "aria-label": "pretend new player is on"
}
const _hoisted_2 = {
  key: 1,
  class: "ng-extend nge-stt",
  "aria-label": "Staging test"
}
const _hoisted_3 = { class: "nge-stt-head" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-stt-title" }, "Staging test", -1 /* HOISTED */))
const _hoisted_5 = { class: "nge-stt-note" }
const _hoisted_6 = { class: "nge-stt-switch" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pretend I am a new player", -1 /* HOISTED */))
const _hoisted_9 = {
  key: 0,
  class: "nge-stt-note nge-stt-reset-done"
}
const _hoisted_10 = { class: "nge-stt-actions" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled", "title"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "nge-stt-verdict" }
const _hoisted_15 = { class: "nge-stt-mark" }
const _hoisted_16 = {
  key: 1,
  class: "nge-stt-note"
}
const _hoisted_17 = { class: "nge-stt-list" }
const _hoisted_18 = { class: "nge-stt-row nge-stt-row--done" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-stt-mark" }, "✓", -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-stt-label" }, "First visit", -1 /* HOISTED */))
const _hoisted_21 = { class: "nge-stt-icons" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "nge-stt-mark" }
const _hoisted_24 = { class: "nge-stt-label" }
const _hoisted_25 = {
  key: 0,
  class: "nge-stt-fill"
}
const _hoisted_26 = { class: "nge-stt-icons" }
const _hoisted_27 = ["title", "innerHTML"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "nge-stt-sub" }
const _hoisted_30 = { class: "nge-stt-icons nge-stt-waiting" }
const _hoisted_31 = ["title", "innerHTML"]
const _hoisted_32 = {
  key: 0,
  class: "nge-stt-none"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-stt-note" }, "Dataset Stats and Batch never arrive by themselves; Settings turns them on. Playing a real tutorial step also brings its icon in. Run the check walks every moment on its own and puts your place back after. Finishing Get Started for real starts the Merge tutorial; the Step button only brings the icons.", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (!$setup.open)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "ng-extend nge-stt-tab",
        onClick: _cache[0] || (_cache[0] = $event => ($setup.setOpen(true))),
        title: "Staging test: step through a new player's first days"
      }, [
        _createTextVNode(" Staging test"),
        ($setup.simulating)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1))
          : _createCommentVNode("v-if", true)
      ]))
    : (_openBlock(), _createElementBlock("aside", _hoisted_2, [
        _createElementVNode("header", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            class: "nge-stt-x",
            onClick: _cache[1] || (_cache[1] = $event => ($setup.setOpen(false))),
            title: "Fold away",
            "aria-label": "Fold away"
          }, "×")
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString($setup.IS_LIVE_SITE ? 'Admins only.' : 'Test site only.') + " Pretend to be a brand new player and step through their first days. Nothing here is saved to your account, except Reset my tutorials.", 1 /* TEXT */),
        _createElementVNode("label", _hoisted_6, [
          _createElementVNode("input", {
            id: "nge-stt-sim",
            type: "checkbox",
            checked: $setup.simulating,
            onChange: $setup.toggleSim
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7),
          _hoisted_8
        ]),
        _createElementVNode("button", {
          id: "nge-stt-reset-tut",
          class: "nge-hud-btn nge-hud-btn--quiet nge-stt-reset",
          onClick: $setup.resetTutorials
        }, _toDisplayString($setup.resetAsk ? 'Click again to reset every tutorial' : 'Reset my tutorials'), 1 /* TEXT */),
        ($setup.resetDone)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Tutorials reset. Get Started is open, and you are a brand new player again."))
          : _createCommentVNode("v-if", true),
        ($setup.simulating)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "nge-hud-btn nge-hud-btn--go",
                  disabled: !$setup.nextMoment,
                  onClick: $setup.stepNext
                }, _toDisplayString($setup.nextMoment ? 'Next: ' + $setup.nextMoment.label : 'All moments done'), 9 /* TEXT, PROPS */, _hoisted_11),
                _createElementVNode("button", {
                  class: "nge-hud-btn nge-hud-btn--quiet",
                  disabled: !$setup.lastStep,
                  title: $setup.lastStep ? 'Undo: ' + $setup.lastStep : 'Nothing to undo',
                  onClick: $setup.back
                }, "‹ Back", 8 /* PROPS */, _hoisted_12),
                _createElementVNode("button", {
                  class: "nge-hud-btn nge-hud-btn--quiet",
                  onClick: $setup.startOver
                }, "Start over"),
                _createElementVNode("button", {
                  id: "nge-stt-check",
                  class: "nge-hud-btn nge-hud-btn--quiet",
                  disabled: $setup.checking,
                  onClick: $setup.runCheck
                }, _toDisplayString($setup.checking ? 'Checking...' : 'Run the check'), 9 /* TEXT, PROPS */, _hoisted_13)
              ]),
              ($setup.results.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["nge-stt-results", $setup.problems ? 'nge-stt-results--bad' : 'nge-stt-results--ok'])
                  }, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString($setup.problems ? `${$setup.problems} problem${$setup.problems === 1 ? '' : 's'} found` : `All ${$setup.results.length} checks passed`), 1 /* TEXT */),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.results, (r, i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          class: _normalizeClass({ 'nge-stt-fail': !r.ok })
                        }, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(r.ok ? '✓' : '✗'), 1 /* TEXT */),
                          _createTextVNode(_toDisplayString(r.text), 1 /* TEXT */)
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _createElementVNode("button", {
                      class: "nge-stt-step",
                      onClick: _cache[2] || (_cache[2] = $event => ($setup.results = []))
                    }, "Hide")
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              ($setup.lastStep)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Back undoes: " + _toDisplayString($setup.lastStep), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("ol", _hoisted_17, [
                _createElementVNode("li", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _createElementVNode("span", _hoisted_21, [
                    _createElementVNode("span", {
                      class: "nge-stt-ic",
                      innerHTML: $setup.def('notif')?.svg
                    }, null, 8 /* PROPS */, _hoisted_22)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.moments, (m) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: m.key,
                    class: _normalizeClass(["nge-stt-row", { 'nge-stt-row--done': $setup.isDone(m.key) }])
                  }, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString($setup.isDone(m.key) ? '✓' : ''), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_24, [
                      _createTextVNode(_toDisplayString(m.label), 1 /* TEXT */),
                      ($setup.FILLS_IN.includes(m.key))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "and anything skipped so far"))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("span", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newIcons[m.key], (id) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: id,
                          class: "nge-stt-ic",
                          title: $setup.def(id)?.label,
                          innerHTML: $setup.def(id)?.svg
                        }, null, 8 /* PROPS */, _hoisted_27))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    (!$setup.isDone(m.key))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "nge-stt-step",
                          onClick: $event => ($setup.step(m.key))
                        }, "Step", 8 /* PROPS */, _hoisted_28))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_29, "Still on the way (" + _toDisplayString($setup.waiting.length) + ")", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.waiting, (id) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: id,
                    class: "nge-stt-ic",
                    title: $setup.def(id)?.label,
                    innerHTML: $setup.def(id)?.svg
                  }, null, 8 /* PROPS */, _hoisted_31))
                }), 128 /* KEYED_FRAGMENT */)),
                (!$setup.waiting.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Nothing. The top bar is complete."))
                  : _createCommentVNode("v-if", true)
              ]),
              _hoisted_33
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]))
}